import Vue from 'vue'
import { API_URL } from '../../api'
import ProjectFinancialsFilter from '../../filters/ProjectFinancialsFilter';
const state = {
    projectFinancialsCreate: {
        createdProjectFinancials: null,
        creatingProjectFinancials: false,
        createProjectFinancialsStatus: null
    },
    projectFinancialsUpdate: {
        updatedProjectFinancials: null,
        updatingProjectFinancials: false,
        updateProjectFinancialsStatus: null
    },
    projectFinancialsDelete: {
        deletingProjectFinancials: false,
        deleteProjectFinancialsStatus: null
    },
    projectFinancialsSearch: {
        projectFinancials: [],
        searchingProjectFinancials: false,
        searchProjectFinancialsStatus: null
    },
}
const mutations = {
    ['SET_PROJECT_FINANCIALS_CREATE'](state, change) {
        state.projectFinancialsCreate = { ...state.projectFinancialsCreate, ...change };
    },
    ['SET_PROJECT_FINANCIALS_UPDATE'](state, change) {
        state.projectFinancialsUpdate = { ...state.projectFinancialsUpdate, ...change };
    },
    ['SET_PROJECT_FINANCIALS_DELETE'](state, change) {
        state.projectFinancialsDelete = { ...state.projectFinancialsDelete, ...change };
    },
    ['SET_PROJECT_FINANCIALS_SEARCH'](state, change) {
        state.projectFinancialsSearch = { ...state.projectFinancialsSearch, ...change };
    }
}
const actions = {
    createProjectFinancials: ({ commit }, payload) => {
        commit('SET_PROJECT_FINANCIALS_CREATE', { createProjectFinancialsStatus: null, createdProjectFinancials: null, creatingProjectFinancials: true })
        return Vue.http.post(API_URL + '/projectFinancials/create', payload).then(response => {
            commit('SET_PROJECT_FINANCIALS_CREATE', { createProjectFinancialsStatus: 'success', createdProjectFinancials: response.body.results.projectFinancials });
        }).catch(response => {
            commit('SET_PROJECT_FINANCIALS_CREATE', { createProjectFinancialsStatus: 'failed' });
        }).finally(() => {
            commit('SET_PROJECT_FINANCIALS_CREATE', { creatingProjectFinancials: false });
        });
    },
    updateProjectFinancials: ({ commit }, payload) => {
        commit('SET_PROJECT_FINANCIALS_UPDATE', { updateProjectFinancialsStatus: null, updatedProjectFinancials: null, updatingProjectFinancials: true })
        return Vue.http.post(API_URL + '/projectFinancials/update/' + payload.id, payload)
            .then(response => {
                commit('SET_PROJECT_FINANCIALS_UPDATE', { updateProjectFinancialsStatus: 'success', updatedProjectFinancials: response.body.results.projectFinancials });
            })
            .catch(response => {
                commit('SET_PROJECT_FINANCIALS_UPDATE', { updateProjectFinancialsStatus: 'failed' });
            })
            .finally(() => {
                commit('SET_PROJECT_FINANCIALS_UPDATE', { updatingProjectFinancials: false });
            })
    },
    deleteProjectFinancials: ({ commit }, id) => {
        commit('SET_PROJECT_FINANCIALS_DELETE', { deleteProjectFinancialsStatus: null, deletedProjectFinancials: null, deletingProjectFinancials: true })
        return Vue.http.delete(API_URL + '/projectFinancials/delete/' + id).then(response => {
            commit('SET_PROJECT_FINANCIALS_DELETE', { deleteProjectFinancialsStatus: 'success' });
        }).catch(response => {
            commit('SET_PROJECT_FINANCIALS_DELETE', { deleteProjectFinancialsStatus: 'failed' });
        }).finally(() => {
            commit('SET_PROJECT_FINANCIALS_DELETE', { deletingProjectFinancials: false });
        })
    },
    searchProjectFinancials: ({ commit }, payload = { filter: ProjectFinancialsFilter(), resultMode: 'default' }) => {
        commit('SET_PROJECT_FINANCIALS_SEARCH', { searchProjectFinancialsStatus: null, searchProjectFinancials: null, searchingProjectFinancials: true })
        let filerJson = JSON.stringify(payload.filter);
        switch (payload.resultMode) {
            case 'count': payload.resultMode = 1; break;
            case 'paginated': payload.resultMode = 2; break;
            case 'paginatedPersist': payload.resultMode = 21; break;
            default: payload.resultMode = 0; break;
        }
        var params = '?query=' + encodeURIComponent(filerJson) + '&result_mode=' + payload.resultMode;
        return Vue.http.get(API_URL + '/projectFinancials' + params).then(response => {
            commit('SET_PROJECT_FINANCIALS_SEARCH', { searchProjectFinancialsStatus: 'success', projectFinancials: response.body.results.projectFinancials });
        }).catch(response => {
            commit('SET_PROJECT_FINANCIALS_SEARCH', { searchProjectFinancialsStatus: 'failed' });
        }).finally(() => {
            commit('SET_PROJECT_FINANCIALS_SEARCH', { searchingProjectFinancials: false });
        })
    },
}
export default {
    state, mutations, actions
} 



// WEBPACK FOOTER //
// ./resources/js/store/modules/projectFinancialsStore.js